<script setup>
  const props = defineProps({
    mode: {
      type: String,
      default: 'default'
    }
  });

  const emits = defineEmits(['selectAll', 'clearAll', 'toggleMode']);
</script>

<template>
  <div class="jwx-modal__section-actions">
    <button
      v-if="mode === 'multi-select'"
      @click.prevent="emits('selectAll')"
      type="button" 
      class="jwx-button jwx-button--pill jwx-button--small"
    >
      Select All
    </button>
    <button
      v-if="mode === 'multi-select'"
      @click.prevent="emits('clearAll')"
      type="button" 
      class="jwx-button jwx-button--pill jwx-button--small"
    >
      Clear All
    </button>
    <button
      @click.prevent="emits('toggleMode')"
      type="button" 
      class="jwx-button jwx-button--pill jwx-button--small jwx-m-left-auto"
      :class="{ 'jwx-button--active': props.mode === 'multi-select' }"
    >
      {{ props.mode === 'multi-select' ? 'Done' : 'Select' }}
    </button>
  </div>
</template>
